"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.BreadcrumbsContainer = void 0;

var _react = _interopRequireWildcard(require("react"));

var _Breadcrumb = _interopRequireDefault(require("./Breadcrumb"));

var _styled = require("./styled");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var getPageThatFetched = function getPageThatFetched(appState) {
  var pageTypes = Object.keys(appState);

  for (var i = 0; i < pageTypes.length; i++) {
    var page = appState[pageTypes[i]];

    if (page.status && page.status === 'success') {
      return pageTypes[i];
    }
  }

  return null;
};

var BreadcrumbsContainer = /*#__PURE__*/function (_Component) {
  _inherits(BreadcrumbsContainer, _Component);

  function BreadcrumbsContainer() {
    _classCallCheck(this, BreadcrumbsContainer);

    return _possibleConstructorReturn(this, _getPrototypeOf(BreadcrumbsContainer).apply(this, arguments));
  }

  _createClass(BreadcrumbsContainer, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return getPageThatFetched(nextProps.appState) !== null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          appState = _this$props.appState,
          breadcrumbTree = _this$props.breadcrumbTree,
          breadcrumbMap = _this$props.breadcrumbMap,
          as = _this$props.as;
      var page = getPageThatFetched(appState);

      if (page) {
        var breadcrumbs = breadcrumbTree[page].map(function (section, i) {
          return _react["default"].createElement(_Breadcrumb["default"], {
            as: as,
            first: i === 0,
            key: section,
            section: section,
            link: breadcrumbMap[section].url(appState),
            text: breadcrumbMap[section].text(appState)
          });
        });
        return _react["default"].createElement(_styled.Breadcrumbs, null, breadcrumbs);
      }

      return null;
    }
  }]);

  return BreadcrumbsContainer;
}(_react.Component);

exports.BreadcrumbsContainer = BreadcrumbsContainer;
var _default = BreadcrumbsContainer;
exports["default"] = _default;

//# sourceMappingURL=BreadcrumbsContainer.js.map